"use strict";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeConfigs = exports.saturationAdjustmentFn = exports.hueRotationFn = void 0;

function hueRotationFn(rotation) {
  return function (hue) {
    return (360 + hue + rotation) % 360;
  };
}

exports.hueRotationFn = hueRotationFn;

function saturationAdjustmentFn(adjustment) {
  return function (saturation) {
    return Math.min(Math.max(saturation + adjustment, 0), 100);
  };
}

exports.saturationAdjustmentFn = saturationAdjustmentFn;

function mergeConfigs(base, extended) {
  return Object.entries(base).reduce(function (accumulator, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        role = _ref2[0],
        variants = _ref2[1];

    var extendedVariants = extended[role];
    var mergedVariants = variants;

    if (extendedVariants != null) {
      extendedVariants.forEach(function (variant) {
        var name = variant.name;
        var indexToReplace = mergedVariants.findIndex(function (baseVariant) {
          return baseVariant.name === name;
        });

        if (indexToReplace === -1) {
          mergedVariants.push(variant);
        } else {
          mergedVariants.splice(indexToReplace, 1, variant);
        }
      });
    }

    return Object.assign(Object.assign({}, accumulator), _defineProperty({}, role, mergedVariants));
  }, {});
}

exports.mergeConfigs = mergeConfigs;